import { Slide } from "@jelly/lesson";

import { task as task04 } from "../../../../../task/course-02/lesson-08/task-04";

const task: Slide = {
  title:
    "Select the best representation for the perception of fluctuation strength (FS) as a function of the modulation frequency:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task04.id,
        },
      },
    },
  },
};

export default task;
